import { render, staticRenderFns } from "./CoachBottomButton.vue?vue&type=template&id=00f052d4&scoped=true&lang=pug"
import script from "./CoachBottomButton.vue?vue&type=script&lang=js"
export * from "./CoachBottomButton.vue?vue&type=script&lang=js"
import style0 from "./CoachBottomButton.vue?vue&type=style&index=0&id=00f052d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f052d4",
  null
  
)

export default component.exports